import appAxios from "services/axios";
import { toQueryParams } from "helpers/url";
import { CreateOrderDTO } from "services/DTO/orders.dto";

class SubOrdersAdminService {
  /**
   * Создание заказа
   * @override
   * @param orderInput 
   * @returns 
   */
  post = (orderInput: CreateOrderDTO, queryParams: any = {}): Promise<any> => {
    return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders?` + toQueryParams(queryParams), orderInput)
  };
  put = (id: string, orderInput: CreateOrderDTO): Promise<any> => {
    return appAxios.put(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/${id}`, orderInput)
  };
  /**
   * Получение заказа
   * @override
   * @param id 
   * @returns 
   */
  get = (id: string): Promise<any> => {
    return appAxios.get(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/${id}`)
  };
  /**
   * Удаление заказа
   * @param id 
   * @returns 
   */
  delete = (id: string): Promise<any> => {
    return appAxios.delete(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/${id}`)
  };


  getAllByOrgID = (orgID: string, queryParams: any = {}): Promise<any> => {
    console.log('queryParams2', queryParams)
    return appAxios.get(`/admin/orgs/${orgID}/sub-orders?` + toQueryParams(queryParams))
  };

  /**
   * Завершение заказа
   * @param bookingID 
   * @returns 
   */
  completeOrder = async (bookingID: string) => {
    return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/${bookingID}/complete`, {});
  };
  /**
   * Отмена заказа
   * @param bookingID 
   * @returns 
   */
  cancelOrder = async (bookingID: string) => {
    return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/${bookingID}/cancel`, {});
  };
  /**
   * Возврат заказа
   * @param bookingID 
   * @returns 
   */
  refundOrder = async (bookingID: string) => {
    return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/${bookingID}/refund`, {});
  };
  /**
   * Получение количества заказов
   * @param queryParams 
   * @returns 
   */
  count = async (queryParams = {}) => {
    const qp = toQueryParams(queryParams)
    return appAxios.get(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/count?${qp}`, {});
  };
  /**
   * Получение клиентов с неоплаченными заказами
   * @param format 
   * @returns 
   */
  unpaidClients = async () => {
    return appAxios.get(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/unpaid-clients`, {});
  };
  hideOrShowPaymentDetails = async (bookingID: string, isPaymentDetailsHidden: boolean) => {
    return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/${bookingID}/hide-or-show-payment-details`, { isPaymentDetailsHidden });
  };
  acceptOrder = async (bookingID: string) => {
    return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/${bookingID}/accept`, {});
  };
  updateSubOrderStatus = async (id: string, status: string) => {
    return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/${id}/update-status`, { status });
  };
  sendToDelivery = async (id: string) => {
    return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/sub-orders/${id}/send-to-delivery`, {});
  };
}

export default new SubOrdersAdminService();
